import React, { memo, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import Icon from '@/components/Base/Icon';

import { Checkbox, Label, Wrapper } from './CheckboxSelect.styles';

function CheckboxSelect({
  label = '',
  isSelected = false,
  name = '',
  onChange = () => {},
  value = '',
}) {
  const [checked, setChecked] = useState(isSelected);
  const didMountCurrent = useRef(false);

  const handleClick = () => {
    onChange({ key: name, value, checked });
    setChecked(!checked);
  };

  useEffect(() => {
    if (didMountCurrent.current) {
      setChecked(isSelected);
    } else {
      didMountCurrent.current = true;
    }
  }, [isSelected]);

  return (
    <Wrapper data-is-checked={checked} onClick={() => handleClick()}>
      <Checkbox>
        <Icon name="checked" />
      </Checkbox>

      <Label>{label}</Label>
    </Wrapper>
  );
}

CheckboxSelect.propTypes = {
  label: PropTypes.string,
  isSelected: PropTypes.bool,
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default memo(CheckboxSelect);
